<div class="container-checkbox mb-5">
  <label>{{ "EVENT.I_WANT_COMPANY_INVOICE" | translate }}
    <input type="checkbox" id="terms-of-sale" (focus)="onClickCompanyInvoice($event.target)">
    <span class="checkmark"></span>
  </label>
</div>

<ng-container *ngIf="companyInvoiceForm && showCompanyInvoice">
  <h1 class="mb-5 mt-5">{{ "EVENT.COMPANY_INVOICE" | translate }}:</h1>

  <form class="user-form user-form-company-invoice" [formGroup]="companyInvoiceForm">
    <div class="user-form-input" *ngFor="let field of fields">
      <label [for]="field.name">{{ field.label }}</label>
      <input
        *ngIf="field.type === 'TEXT'"
        [id]="field.name"
        [formControlName]="field.name"
        [attr.maxLength]="field.length"
        [readonly]="!field.changeable"
        [class.disabled]="companyInvoiceForm.get(field.name)?.disabled"
      />
    </div>
  </form>

  <p class="error-message mb-5 mt-3">{{ errorMessage }}</p>
</ng-container>
